(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.SalesCoachWOO",
            {
                url: "/SalesCoachWOO",
                component: "salescoachwoo",
                PageTitle: "Sales Coach - Windows of Opportunity",
                requiredPermissions: "SalesCoachWindowsOfOpportunity:View",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }]
                }
            });
        }
    ]);

    app.component("salescoachwoo",
    {
        templateUrl: "App/Resources/SalesCoachWOO/SalesCoach.html",
        controller: salesCoachCtrl,
        bindings: {
            states: "<"
        }
    });

    salesCoachCtrl.$inject = ["eligibilityFormDialog", "surveys", "eligibilityFormApi", "amplitudeService"];

    function salesCoachCtrl(eligibilityFormDialog, surveys, eligibilityFormApi, amplitudeService) {

        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        surveys.then(function (s) {
            eligibilityFormApi.isEnrolled(s.salesCoachWindowsofOpportunityId).then(function (response) {
                $ctrl.submitted = response;
            });
        });       

        /*  Open the Enrollment Form  */
        $ctrl.openDialog = function (event) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.salesCoachWindowsofOpportunityId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        }
    }  
})(window.app, window.angular); // jshint ignore:line